module.exports = __webpack_public_path__ + "files/dbdbad894daaf6b5c74bf81799510258.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/droidserif-bolditalic-webfont.svg
 ** module id = 900
 ** module chunks = 0
 **/